import { ArrowForward, ElectricBolt, WbSunnyOutlined } from '@mui/icons-material'
import { EnergyData } from '../../types/charts'
import { DashboardViewProps, ProductionStatWidgetConfig, TestViewProps, Widget } from './Widget'
import { Link } from 'react-router-dom'
import { Box } from '@mui/system'
import { Trans } from 'react-i18next'
import { sprintf } from 'sprintf-js'
import { Series } from '../../utils/series'
import { SolarPortControl } from '../ports/SolarPortControl'

export class ProductionStatWidget extends Widget<{ energy: EnergyData[] }, ProductionStatWidgetConfig> {

  get Icon() {
    return ElectricBolt
  }

  get width() {
    return 2
  }

  get height() {
    return 3
  }

  get bgColor() {
    return 'forth.main'
  }

  get textColor() {
    return 'forth.contrastText'
  }

  solarControls(): SolarPortControl[] {
    return this.findControslByFilter(ctrl => ctrl.port.type === 'SOLAR') as SolarPortControl[]
  }

  dataUrls(): Record<string, string> {
    const ret: Record<string, string> = {
    }
    const [from, to] = this.dateRange()
    const solars = this.solarControls()
    if (solars.length > 0) {
      ret.energy = `/history/power/${solars[0].port.id}?from=${from}&to=${to}&steps=minute`
    }

    return ret
  }

  draw(props: DashboardViewProps): React.ReactElement {
    const total = this.data?.energy ? Series.totalEnergy(this.data.energy) : 0
    const power = this.solarControls()[0].getValue<number|null>('power')
    return (
      <Box
        data-cy="box-Solar energy produced"
        sx={{
          p: 2,
          display: 'grid',
          gridTemplateColumns: '3fr 1fr',
        }}>
        <Box sx={{ fontSize: '2rem', color: this.textColor }}>
          {power === undefined ? '—' : sprintf('%.0f', power)}
          <Box component="span" sx={{ fontSize: '1rem' }}> W</Box>
        </Box>

        <Box sx={{ fontSize: '2rem', textAlign: 'center', color: '#F4E356' }}><WbSunnyOutlined/></Box>
        <Box sx={{ p: 0.5, lineHeight: 1.3, fontSize: '0.75rem' }}><Trans>Solar energy produced</Trans>:<br/> {sprintf('%.1f', total)} kWh</Box>
        <Box sx={{ mt: 3, textAlign: 'right', color: this.textColor }}>
        {
          !props.testing && <Link to="/history/#Production">
            <ArrowForward sx={{ color: this.textColor }}/>
          </Link>
        }
        </Box>
      </Box>
    )
  }

  drawTestView(props: TestViewProps) {
    return this.dashboardView({
      testing: true,
      refresh: () => null
    })
  }
}
